import { Suspense, lazy, FC } from 'react';
import { useSelector } from 'react-redux';

// types
import { AuctionTooltipContentType } from './PdpSharedAuctionTooltipType';

const PdpSharedAuctionTooltip = lazy(
    () => import(/* webpackChunkName: "PdpSharedAuctionTooltip" */ './PdpSharedAuctionTooltip')
);

type Props = {
    type: AuctionTooltipContentType;
    size?: 'small' | 'medium';
};

type RelayVariables = {
    isClient: boolean;
};

type ReduxStoreType = {
    relayVariables: {
        variables: RelayVariables;
    };
};

export const PdpSharedAuctionTooltipLazy: FC<Props> = ({ type, size = 'medium' }) => {
    const { isClient } = useSelector<ReduxStoreType, RelayVariables>(
        relay => relay?.relayVariables?.variables || {}
    );

    if (!isClient) {
        return null;
    }

    return (
        <Suspense fallback={null}>
            <PdpSharedAuctionTooltip type={type} size={size} />
        </Suspense>
    );
};
